module.exports = __webpack_public_path__ + "img/email.21389ec5.svg";